// extracted by mini-css-extract-plugin
export default {"card":"FlipCard_card__GvnbH","cardIcon":"FlipCard_cardIcon__RwbLn","cardTitle":"FlipCard_cardTitle__seLTB","description":"FlipCard_description__Aj45W"};